import PropTypes from 'prop-types';
import { Box, Typography, Checkbox, Radio } from '@mui/material';
import { choiceGridSx, choiceItemSx } from '../styles';

const ChoiceGrid = ({
  options = [],
  selectedValues = [],
  onChange,
  type = 'checkbox', // 'checkbox' or 'radio'
  single = false, // Single column layout
  name,
}) => {
  const handleChange = (optionValue) => {
    if (type === 'radio') {
      onChange?.([optionValue]);
    } else {
      const newValues = selectedValues.includes(optionValue)
        ? selectedValues.filter((v) => v !== optionValue)
        : [...selectedValues, optionValue];
      onChange?.(newValues);
    }
  };

  return (
    <Box sx={choiceGridSx(single)}>
      {options.map((option) => {
        const value = typeof option === 'string' ? option : option.value;
        const label = typeof option === 'string' ? option : option.label;
        const isSelected = selectedValues.includes(value);

        return (
          <Box
            key={value}
            onClick={() => handleChange(value)}
            sx={choiceItemSx(isSelected)}
          >
            {type === 'radio' ? (
              <Radio
                checked={isSelected}
                name={name}
                size="small"
                sx={{
                  padding: 0,
                  '& .MuiSvgIcon-root': { fontSize: 18 },
                  color: '#BDBDBD',
                  '&.Mui-checked': { color: '#00A76F' },
                }}
              />
            ) : (
              <Checkbox
                checked={isSelected}
                size="small"
                sx={{
                  padding: 0,
                  '& .MuiSvgIcon-root': { fontSize: 18 },
                  color: '#BDBDBD',
                  '&.Mui-checked': { color: '#00A76F' },
                }}
              />
            )}
            <Typography sx={{ fontSize: 14, color: '#212B36' }}>
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

ChoiceGrid.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ])
  ),
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  single: PropTypes.bool,
  name: PropTypes.string,
};

export default ChoiceGrid;
